@use "~theme/typographyV2" as typography;

.radioButtonContainer {
  display: inline-flex;
  position: relative;
  align-items: center;
}

.radioButton {
  background-image: url("~images/radio-button-empty.svg");
  background-repeat: no-repeat;
  background-position: center center;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  font-family: typography.$font-mont;
}

.radioButton.error {
  background-image: url("~images/radio-button-error.svg");
}

.radioButtonCAIM {
  background-image: url("~images/radio-button-empty.svg");
  background-repeat: no-repeat;
  background-position: center center;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.radioButton.error {
  background-image: url("~images/radio-button-error.svg");
}

.nativeRadioButton {
  opacity: 0.01; // Visible to Capybara but not to humans
  position: absolute;
  width: 100%;
  height: 100%;
}

.nativeRadioButton:checked + .radioButton {
  background-image: url("~images/radio-button-filled.svg");
}

.nativeRadioButton:focus + .radioButton {
  box-shadow: 0 0 12px var(--highlight-blue);
}

.label {
  @include typography.body;
  margin-left: 8px;
}
